export const FACE_MATCH_PROVIDER_ROUTE_PATHS = {
  faceMatchProvider: '/users/face-match-provider',
};

export const FACE_MATCH_PROVIDER_API_PATHS = {
  providers: '/v1/api/platform/face-match-provider/providers',
  userProvider: '/v1/api/platform/face-match-provider/users/:userId',
};
